<template>
    <div>
        <!-- dialog -->
        <v-dialog v-model="dialog" width="400" @keydown.esc="dialog = false">
            <v-card>
                <div class="d-flex justify-end py-1 background-title-card ">
                    <v-card-title
                        class="text-uppercase text-subtitle-1 d-flex justify-center w-100 px-0 py-0 white--text"
                    >
                        {{ companyId ? $t('companies.edit-company') : $t('companies.add-company') }}
                    </v-card-title>
                    <!-- close button -->
                    <v-btn icon @click="dialog = false">
                        <v-icon color="white">
                            mdi-close-circle-outline
                        </v-icon>
                    </v-btn>
                </div> 
                <v-form ref="form">
                    <v-card-text class="pt-6 pb-0">
                        <v-row>
                            <v-col cols="12" class="pa-1">
                                <v-text-field 
                                    v-model="name"
                                    :label="$t('inputs.name')"
                                    dense
                                    hide-details
                                    outlined
                                    :disabled="submitLoading"
                                    :rules="rules.required"
                                />
                            </v-col>

                            <v-col cols="6" class="pa-1">
                                <v-text-field
                                    v-model="address"
                                    :label="$t('inputs.address')"
                                    dense
                                    hide-details
                                    outlined
                                    :disabled="submitLoading"
                                    :rules="rules.required"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="6" class="pa-1">
                                <v-text-field
                                    v-model="currency"
                                    :label="$t('inputs.currency')"
                                    dense
                                    hide-details
                                    outlined
                                    :disabled="submitLoading"
                                    :rules="rules.required"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>

                    <v-card-actions>
                        <v-spacer />
                        <v-btn
                            text
                            color="success"
                            :loading="submitLoading"
                            :disabled="submitLoading"
                        >
                            {{$t('save')}}
                        </v-btn>

                        <v-btn
                            :disabled="submitLoading"
                            text
                            @click="dialog = false"
                        >
                            {{$t('cancel')}}
                        </v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- delete dialog -->
        <delete-dialog ref="DeleteDialog" @on-delete="getAll">
            <p class="mb-0 text-body-1">
                {{ $t('are-you-sure-you-want-to') }} <span class="red--text">{{ $t('delete') }}</span> {{ $t('companies.this.company') }} {{$t('?')}}
            </p>
        </delete-dialog>
        <v-btn 
            @click="dialog = true"
            class="d-flex justify-end text-none"      
            small
            color="light-blue white--text"
            :disabled="loading"
        > 
            <v-icon small> mdi-plus </v-icon>
            {{$t('companies.add-company')}} 
        </v-btn>
        <v-spacer />
        <bee-handy-table
            :items="companies"
            :headers="headers"
            zebra
            dense
            :items-per-page="-1"
            hide-default-footer
            class="mt-1"
            fixed-header
            :height="$vuetify.breakpoint.height - 80"
            :loading="loading"
        >
            <template v-slot:item.actions="{ item }">
                <div>
                    <!-- edit -->
                    <tooltip :text="$t('edit')" top>
                        <v-btn
                            icon
                            small
                            color="success"
                            class="me-2"
                            @click="companyId = item.id; dialog = true"
                            :disabled="loading"
                        >
                            <v-icon>mdi-pencil</v-icon>
                        </v-btn>
                    </tooltip>

                    <!-- delete -->
                    <tooltip :text="$t('delete')" top>
                        <v-btn
                            icon
                            small
                            color="red lighten-1"
                            @click="$refs.DeleteDialog.activeDeleteDialog(item.id, 'companies')"
                            :disabled="loading"
                        >
                            <v-icon>mdi-delete</v-icon>
                        </v-btn>
                    </tooltip>
                </div>
            </template>
        </bee-handy-table>
    </div>
</template>

<script>
import rules from '@/validation rules'
import DeleteDialog from '@/components/DeleteDialog.vue'
export default {
    components: {
        DeleteDialog
    },
    data () {
        return {
            companies: [],
            companyId: null,
            dialog: false,
            submitLoading: false,
            loading: false,
            rules,
            name: null,
            address: null,
            currency: null
        }
    },

    watch: {
        dialog (val) {
            if (!val) {
                this.name = null
                this.address = null
                this.currency = null
                this.companyId = null
                this.$refs.form.resetValidation()
            } else {
                if (this.companyId) {
                    const item = this.companies.find(c => c.id === this.companyId)
                    this.name = item.name
                    this.address = item.address
                    this.currency = item.currency
                }
            }
        }
    }, 

    computed: {
        headers (){
            return [
                {
                    text: this.$t('headers.name'),
                    name: 'company',
                    value: 'company'
                },
                {
                    text: this.$t('headers.name'),
                    name: 'address',
                    value: 'address'
                },
                {
                    text: this.$t("headers.currency"),
                    name: 'currency',
                    value: 'currency'
                },
                {
                    text: '',
                    name: 'actions',
                    value: 'actions'
                }
            ]
        }
    },

    methods: {
        getAll() {
            // this.loading = true 
            // return this.$store.dispatch('companies/fetchAll').finally(() => { this.loading = false })
        },
        submit () {
            if (this.$refs.form.validate()) {
                this.submitLoading = true
                const actionName = this.companyId ? 'update' : 'create'
                this.$store.dispatch(`companies/${actionName}`, { 
                    name: this.name,
                    currency: this.currency,
                    address: this.address,
                    id: this.companyId
                }).then(() => {
                    this.getAll().then(() => {
                        this.dialog = false
                    })
                }).finally(() => {
                    this.submitLoading = false
                    this.companyId = null
                })
            }
        }
    },

    created () {
        this.getAll()
    }
}
</script>
